<template>
  <div class="farm-window farm-list-card sales-card" :style="cssVars">
    <h2 style="grid-area: t;">Sales</h2>
    <p style="grid-area: x; margin: auto 0; text-align: right;"></p>
    <div class="option-buttons" style="grid-area: a; grid-template-columns: 1fr 1fr">
      <p>Storage</p>
      <p>Milk Price</p>
    </div>

    <div class="option-buttons" style="grid-area: s; grid-template-columns: 1fr">
      <ValueMeter :container="farm.state.milk" barColor="#abc" style="" title="How much milk you have and can store.">
        <p class="milk-label">
          {{ util.showNumber(farm.state.milk.value) }} / {{ util.showNumber(farm.state.milk.max) }} L
        </p>
      </ValueMeter>
    </div>

    <div class="option-buttons" style="grid-area: p; grid-template-columns: 4fr 1fr 1fr">
      <ValueMeter :container="farm.state.milkPrice" barColor="#036626" style="border-right: 0;"
                  title="Selling for a higher price means that you won't be able to sell as much.">
        <p class="milk-label">
          ${{ farm.state.milkPrice.value.toFixed(0) }} / ${{ farm.state.milkPrice.max.toFixed(0) }}
        </p>
      </ValueMeter>
      <TextButton class="farm-button" @click="farm.state.milkPrice.addValue(-farm.state.market.marketIntensity.value)">
        <p>
          <b>-</b>
        </p>
      </TextButton>
      <TextButton class="farm-button" @click="farm.state.milkPrice.addValue(farm.state.market.marketIntensity.value)">
        <p>
          <b>+</b>
        </p>
      </TextButton>
    </div>

    <div class="option-buttons" style="grid-area: c; grid-template-columns: 1fr">
      <p>Demand</p>
    </div>
    <div class="option-buttons" style="grid-area: d; grid-template-columns: 1fr"
         title="How much milk people want to buy. When demand becomes full, the market will experience more competition.">
      <ValueMeter :container="farm.state.market.demand" barColor="#abc" style="">
        <p class="milk-label">
          {{ util.showNumber(farm.state.market.demand.value) }} / {{ util.showNumber(farm.state.market.demand.max) }} L ({{ util.showNumber(farm.state.market.demandGeneration * 60) }} L/day)
        </p>
      </ValueMeter>
    </div>

    <!--<div class="option-buttons" style="grid-area: e; grid-template-columns: 1fr">
      <p class="milk-label">
        Price Level
      </p>
    </div>
    <div class="option-buttons" style="grid-area:f; grid-template-columns: 1fr">
        <p class="milk-label" title="Measure of the maximum amount people want to pay. Higher demand and less competition means higher price.">
          {{ farm.state.market.marketDepth }}
        </p>
    </div>-->

    <div class="option-buttons" style="grid-area: e; grid-template-columns: 1fr">
      <p class="milk-label">
        Market Level
      </p>
    </div>
    <div class="option-buttons" style="grid-area: f; grid-template-columns: 1fr;"
         title="How big the market is, and how much competition there is.">
      <p class="milk-label">
        {{ farm.state.market.marketWidth }}
      </p>
    </div>

    <div class="option-buttons" style="grid-area: i; grid-template-columns: 1fr">
      <template v-if="farm.state.market.sellCooldown.fraction === 0">
        <TextButton class="farm-button" @click="farm.sell()">
          <p>
            <b>Sell </b>
            <span>(max {{ farm.state.market.predictSaleAmount(farm.state.milkPrice.value).toFixed(1) }} L)</span>
          </p>
        </TextButton>
      </template>
      <template v-else>
        <TextButton class="farm-button disabled-button">
          <p>
            <b>{{ util.displayTime(farm.state.market.sellCooldown.value) }}</b>
          </p>
        </TextButton>
      </template>
    </div>

    <!--
    <div class="option-buttons" style="grid-area: d; grid-template-columns: 1fr">
      <p class="milk-label">
        Market Depth: {{ farm.state.market.marketDepth }}
      </p>
    </div>

    <div class="option-buttons" style="grid-area: f; grid-template-columns: 1fr; background-color: #333;">
      <p class="milk-label">
        Market Width: {{ farm.state.market.marketWidth }}
      </p>
    </div>-->
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Employee from '@/employee/Employee'
import Farm from '@/farm/Farm'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import TextButton from '@/components/ui/TextButton.vue'
import util from '@/util'

@Options({
  components: {
    ValueMeter, TextButton
  },
  props: {
    employee: Employee, farm: Farm
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  },
  computed: {
    cssVars() {
      return {
        '--background-image': 'url(' + require('@/assets/wolfgang-hasselmann.jpg') + ')'
      }
    },
    util() {
      return util
    }
  }
})
export default class SalesCard extends Vue {
  farm!: Farm
}
</script>

<style scoped lang="scss">
  .sales-card {
    width: 100%;
    min-height: 200px;
    max-height: none;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 30px 20px 40px 10px 20px 40px;
    grid-template-areas:
      "t t t x x x"
      "a a a a a a"
      "s s s p p p"
      ". . . . . ."
      "c c c e i i"
      "d d d f i i";
    grid-gap: 2px;
  }

  .value-meter {
    margin-top: auto;
    margin-bottom: auto;
    height: 90%;
  }

  .option-buttons {
    display: grid;
    grid-auto-columns: 2fr 1fr;
    grid-auto-flow: column;
    width: 100%;

    p {
      text-align: center;
      margin-top: auto;
      margin-bottom: auto;
      font-weight: bold;
    }

    .text-button {
      display: table;
      margin-top: auto;
      margin-bottom: auto;
      height: 90%;
      border: $component-border-style;
      border-right: 0;

      &:last-child {
        border: $component-border-style;
      }

      p {
        display: table-cell;
        vertical-align: middle;
      }
    }

    .selected-button {
      background-color: scale-color(darken($highlight-color, 10%), $saturation: -10%);
      //border-color: $highlight-color;
      p {
        //color: $highlight-color;
      }
    }
  }

</style>
